<template>
  <div class="ps_form_builder" :class="className">
    <div class="ps_form_field">
        <div>
            <div>
                <InputField
                    v-if="isEditId"
                    v-model="field.id"
                    :placeholder="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.ID.PLACEHOLDER')"
                    :disabled="disabled"
                    :error="v.id.$error ? $t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.ID.ERR') : ''"
                />
                <p v-else class="paragraph">{{field.id}}</p>
            </div>
            <div class="card_heading">
                <InputField
                    v-model="field.label"
                    :placeholder="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.PLACEHOLDER')"
                    :disabled="disabled"
                    :error="v.label.$error ? $t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.QUESTION.ERR') : ''"
                />
                <InputSlot>
                    <multiselect
                        v-model="field.type"
                        class="column small-12"
                        :options="fieldTypeOptions"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :hide-selected="true"
                        :placeholder="'Select'"
                        :label="fieldTypeLabelBy"
                        :track-by="fieldTypeTrackBy"
                        :selectLabel="''"
                        :disabled="disabled"
                    />
                </InputSlot>
            </div>
            <div class="pb_10">
                <InputField
                    v-if="fieldBodyType === 'text'"
                    :disabled="true"
                    :value="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.SHORT_ANS.PLACEHOLDER')"
                />
                <InputField
                    v-if="fieldBodyType === 'textarea'"
                    :disabled="true"
                    :value="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.LONG_ANS.PLACEHOLDER')"
                />
                <InputField
                    v-if="fieldBodyType === 'date'"
                    :disabled="true"
                    type="date"
                />
                <InputField
                    v-if="fieldBodyType === 'time'"
                    :disabled="true"
                    type="time"
                />
                <div style="width:fit-content;">
                    <InputField
                        v-if="fieldBodyType === 'file'"
                        :disabled="true"
                        type="file"
                    />
                </div>

                <div v-if="fieldBodyType === 'dropdown'">
                    <FormBuilderOptionItem
                        v-for="(optionEl,i) in field.options"
                        v-model="field.options[i]"
                        :key="i"
                        className="mb_6"
                        iconType="numbering"
                        :serialNo="i+1"
                        :index="i"
                        @onDeleteOption="onDeleteOption"
                    />
                    <!-- add btn  -->
                    <div class="filter-actions">
                        <woot-button
                            class="clear"
                            color-scheme="primary"
                            icon="add"
                            variant="clear"
                            size="small"
                            @click="$emit('appendNewOption',field)"
                        >
                            {{ $t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.DROPDOWN.ADD_BTN') }}
                        </woot-button>
                    </div>
                </div>
                <div v-if="fieldBodyType === 'checkbox'">
                    <FormBuilderOptionItem
                        v-for="(optionEl,i) in field.options"
                        v-model="field.options[i]"
                        :key="i"
                        className="mb_6"
                        iconType="checkbox"
                        :serialNo="i+1"
                        :index="i"
                        @onDeleteOption="onDeleteOption"
                    />
                    <!-- add btn  -->
                    <div class="filter-actions">
                        <woot-button
                            class="clear"
                            color-scheme="primary"
                            icon="add"
                            variant="clear"
                            size="small"
                            @click="$emit('appendNewOption',field)"
                        >
                            {{ $t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.DROPDOWN.ADD_BTN') }}
                        </woot-button>
                    </div>
                </div>
                <div v-if="fieldBodyType === 'radio'">
                    <FormBuilderOptionItem
                        v-for="(optionEl,i) in field.options"
                        v-model="field.options[i]"
                        :key="i"
                        className="mb_6"
                        iconType="radio"
                        :serialNo="i+1"
                        :index="i"
                        @onDeleteOption="onDeleteOption"
                    />
                    <!-- add btn  -->
                    <div class="filter-actions">
                        <woot-button
                            class="clear"
                            color-scheme="primary"
                            icon="add"
                            variant="clear"
                            size="small"
                            @click="$emit('appendNewOption',field)"
                        >
                            {{ $t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.DROPDOWN.ADD_BTN') }}
                        </woot-button>
                    </div>
                </div>
                <InputField
                   v-model="field.description"
                    :placeholder="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.DESCRIPTION.PLACEHOLDER')"
                    :disabled="disabled"
                />
            </div>
            <div class="card_footer">
                <div>
                    <InputSlot v-if="isEditBindTo">
                        <multiselect
                            v-model="field.bind_to"
                            class="column small-12 builder_select"
                            :options="bindOptions"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="'Select'"
                            :label="bindLabelBy"
                            :track-by="bindTrackBy"
                            :selectLabel="''"
                            :disabled="disabled"
                        />
                    </InputSlot>
                    <p v-else-if="field.bind_to" class="paragraph">{{field.bind_to.name}}</p>
                </div>
                <div class="builder_actions">
                    <ToggleField
                        v-model="field.required"
                        className="mb_0"
                        :label="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.FIELD.REQUIRED')"
                        @onToggle="onToggleRequired"
                    />
                    <woot-button
                        variant="smooth"
                        color-scheme="secondary"
                        icon="copy"
                        size="small"
                        class-names="margin-right-button"
                        @click="onCopyField"
                    />
                    <woot-button
                        v-if="!disabled"
                        class=""
                        variant="smooth"
                        color-scheme="alert"
                        icon="dismiss-circle"
                        class-names=""
                        size="small"
                        @click="onDeleteField"
                    />
                </div>
            </div>
        </div>

    </div>
    <!-- add toolbar vertical -->
    <div class="toolbar_vertical  py_6">
        <woot-button
            v-tooltip.top="'Add new question'"
            variant="smooth"
            color-scheme="secondary"
            icon="add-circle"
            size="small"
            class-names="margin-right-button"
            @click="$emit('onAddNewField',index)"
        />
        <woot-button
            v-if="!disabled"
            v-tooltip.top="'Edit id'"
            variant="smooth"
            color-scheme="secondary"
            icon="edit"
            size="small"
            class-names="margin-right-button"
            @click="toggleEditId"
        />
        <woot-button
            v-if="!disabled"
            v-tooltip.top="'Edit attribute'"
            variant="smooth"
            color-scheme="secondary"
            icon="contact-card-group"
            size="small"
            class-names="margin-right-button"
            @click="toggleEditBindTo"
        />
    </div>
  </div>
</template>

<script>
import InputField from "components/ui/inputs/InputField.vue";
import InputSlot from 'components/ui/inputs/MultiselectDropdown.vue';
import ToggleField from 'components/ui/inputs/ToggleField.vue';
import FormBuilderOptionItem from 'components/ui/FormBuilderOptionItem.vue';

export default {
    components: {
        InputField,
        InputSlot,
        ToggleField,
        FormBuilderOptionItem,
    },
    props:{
        field:{
            type:Object,
            default: ()=>({}),
            required: true
        },
        v:{
            type: Object
        },
        fieldBodyType:{
            type: String
        },
        index:{
            type: Number,
        },
        bindOptions:{
            type: Array,
            default: ()=>([])
        },
        bindTrackBy:{
            type: String,
            default: ''
        },
        bindLabelBy:{
            type: String,
            default: ''
        },
        fieldTypeOptions:{
            type: Array,
            default: ()=>([])
        },
        fieldTypeTrackBy:{
            type: String,
            default: ''
        },
        fieldTypeLabelBy:{
            type: String,
            default: ''
        },
        className:{
            type: String,
            default: ''
        },
        disabled:{
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
            isEditId:false,
            isEditBindTo:false,
        }
    },
    methods:{
        onCopyField(){
            this.$emit('onCopyField',{index:this.index,field:this.field})
        },
        onDeleteField(){
            this.$emit('onDeleteField',{index:this.index,field:this.field})
        },
        onToggleRequired(){
            this.$emit('onToggleRequired',{index:this.index,field:this.field})
            // this.field.required = !this.field.required;
        },
        onDeleteOption(optionIndex) {
            if (Array.isArray(this.field.options)) {
                this.field.options.splice(optionIndex, 1); // Remove option reactively
            }
        },
        toggleEditId(){
            this.isEditId = !this.isEditId;
        },
        toggleEditBindTo(){
            this.isEditBindTo = !this.isEditBindTo;
        },
    },
}
</script>


<style lang="scss" scoped>
.ps_form_builder{
    position: relative;
    display: grid;
    grid-template-columns: 1fr 60px;
    gap: 10px;

    .ps_form_field{
        border: 1px solid #EEE;
        padding: 14px;
        border-radius: 8px;
        box-shadow: 0 0 4px 1px #f9f9f9;

    }

    .toolbar_vertical{
        border: 1px solid #eee;
        background: #fff;
        border-radius: 5px;

        display: none;
        // display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 4px;
    }
    &:hover{
        .toolbar_vertical{
            display: flex;
        }
    }
}
.card_heading{
    display: grid;
    grid-template-columns: 1fr 200px;
    gap: 10px;
}
.card_footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #eee;
    padding-top: 10px;
    .builder_actions{
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }
}
.filter-actions{
    margin-left: 60px;
}
</style>

<style scoped>
.ps_form_builder .builder_actions .toggle_field {
    margin: 0 !important;
}
.ps_form_builder .input_label {
    margin-bottom: 0 !important;
}
.ps_form_builder .builder_select{
    margin: 0;
}
</style>